import React from "react"
import { postExcel } from "@ui-seeker/utils"

import { isLoadingCommonFilters } from "@signals"
import { BITable } from "./@components"
import { BIAggregationPrice, BIAsked, BIFilters, BIIs3DTable, BIIsLoadingTable, BISelectedOfficeOptions, BITableData } from './@signals'
import { excelSentence } from './@services/sentence'
import { BACKEND_APIS } from "@constants"
import { AppResultsSkeleton } from "@components"


export default function BITableContent() {

	if ((!BITableData.value.rowValues?.length && !BISelectedOfficeOptions.value?.length) || BIIs3DTable.value ) return null
	if (BIIsLoadingTable.value || isLoadingCommonFilters.value) return <AppResultsSkeleton/>

	return <BITable
		dataTable={BITableData.value.trows?.[BIAggregationPrice.value] || []}
		columnValues={BITableData.value.columnValues}
		filters={BIFilters.value}
		options={{
			// the sentence of the question on screen is the Excel's first row (CU-869fmk5ge CA 13)
			onDownload: () => postExcel(`${BACKEND_APIS.DASHBOARD}/excel`, { ...BIFilters.value, querySentence: excelSentence(BIAsked.value, BIAggregationPrice.value) })
		}}
	/>
}